<template>
	<div class="new-index">
		<IndexSocket ref="robotSocketRef" :nowTime='nowTime' @backSockertData='doSocker($event)' />
		<div class="heard">
			<div class="title-img"><img :src="titleUrl" alt="" /></div>
			<div class="title">智能机器人监控平台</div>
			<!-- <div class="title">员工监控操作平台</div> -->
			<div class="title-time">
				<div class="time-ll">
					{{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}:{{ newTime.getSeconds() < 10 ? '0' + newTime.getSeconds() : newTime.getSeconds() }}
				</div>
				<div class="time-li">
					<div style="text-align: right;">
						<span v-if="newTime.getDay() === 0">星期日</span>
						<span v-else-if="newTime.getDay() === 1">星期一</span>
						<span v-else-if="newTime.getDay() === 2">星期二</span>
						<span v-else-if="newTime.getDay() === 3">星期三</span>
						<span v-else-if="newTime.getDay() === 4">星期四</span>
						<span v-else-if="newTime.getDay() === 5">星期五</span>
						<span v-else-if="newTime.getDay() === 6">星期六</span>
					</div>
					<div style="margin-top: 5px;">
						{{newTime.getFullYear()}}-{{newTime.getMonth() + 1}}-{{ newTime.getDate() < 10 ? '0' + newTime.getDate() : newTime.getDate()}}
					</div>
				</div>
			</div>
		</div>

		<div class="content">
			<div class="content-left">
				<div class="content-left-top left-sc-li">
					<div class="left-li-top">
						<div class="echarts-div">
							<div class="eChart-title">机器人</div>
							<div style="width: 100%;display: inline-block;height: calc(100% - 45px);">
								<div style="width: 49%;height: 100%;display: inline-block;" class="robot-body">
									<div v-for="(obj, index) in robotAry" :key="index">
										<span>{{ obj.robotName }}</span>
										<span>{{ obj.routeName }}</span>
										<span>{{ obj.onlineStatus === '1' ? obj.ststusName : '离线'}}</span>
									</div>
								</div>
								<div style="width: 49%;height: 100%;display: inline-block;" id="body-li0">
								</div>
							</div>
						</div>
					</div>
					<div class="left-li-content"></div>
					<div class="left-li-bottom"></div>
				</div>
				<div class="content-left-content left-sc-li">
					<div class="left-li-top">
						<div class="echarts-div">
							<div class="eChart-title">报警统计 & 机器人数量</div>
							<div
								style="width: 100%;display: flex;height: calc((100% - 50px) / 2);justify-content: space-between;align-items: center;border-bottom: 2px solid #02314d;">
								<div style="display: flex;align-items: center;margin: 0 50px;">
									<img :src="error_ul" style="width: 50px;margin: 0 10px;">
									<span style="font-size: 16px;color: rgb(18,150,219);font-weight: 600;">总数：<span
											style="font-weight: 900;">{{ errorData.totalNum }}</span></span>
								</div>
								<div style="display: flex;align-items: center;margin: 0 50px;">
									<img :src="error_li" style="width: 50px;margin: 0 10px;">
									<span style="font-size: 16px;color: rgb(216,30,6);font-weight: 600;">未处理：<span
											style="font-weight: 900;">{{ errorData.untreatedNum }}</span></span>
								</div>
							</div>
							<div
								style="width: 100%;display: flex;height: calc((100% - 50px) / 2);justify-content: space-between;align-items: center;">
								<div style="display: flex;align-items: center;margin: 0 50px;">
									<img :src="robot_li" style="width: 50px;margin: 0 10px;">
									<span style="font-size: 16px;color: rgb(18,150,219);font-weight: 600;">总数：<span
											style="font-weight: 900;">{{ errorObj.totalNum }}</span></span>
								</div>
								<div style="display: flex;align-items: center;margin: 0 50px;">
									<img :src="robot_ul" style="width: 45px;margin: 0 20px;">
									<span style="font-size: 16px;color: white;font-weight: 600;">在岗：<span
											style="font-weight: 900;">{{ errorObj.onDuty }}</span></span>
								</div>
							</div>
						</div>
					</div>
					<div class="left-li-content"></div>
					<div class="left-li-bottom"></div>
				</div>
				<div class="content-left-bottom left-sc-li">
					<div class="left-li-top">
						<div class="echarts-div">
							<div class="eChart-title">维修 & 保养</div>
							<div style="width: 100%;display: inline-block;height: calc(100% - 45px);">
								<div style="width: 49%;height: 100%;display: inline-block;" id="body-li1">
								</div>
								<div style="width: 49%;height: 100%;display: inline-block;" id="body-li1-1">
								</div>
							</div>
						</div>
					</div>
					<div class="left-li-content"></div>
					<div class="left-li-bottom"></div>
				</div>
			</div>
			<div class="content-center">
				<div class="center-top corner-border">
					<div class="left-li-top" style="font-size: 15px;">运行信息</div>
					<div style="width: 100%;display: inline-block;height: calc(100% - 45px);">
						<div style="width: 100%;height: 100%;display: inline-block;position: relative;" id="body-li4">
							<div
								style="position: absolute;width: 100%;height: 100%;top: 0;left: 0;display: flex;align-items: center;justify-content: center;">
								<div class="numberli">{{ funReal < 5 ? 0 : parseInt((funNum % 1000000000)/100000000) }}
								</div>
								<div class="numberli">{{ parseInt((funNum % 100000000)/10000000) }}</div>
								<div class="numberli">{{ parseInt((funNum % 10000000)/1000000) }}</div>
								<div class="numberli">{{ parseInt((funNum % 1000000)/100000) }}</div>
								<div class="numberli">{{ parseInt((funNum % 100000)/10000) }}</div>
								<div class="numberli">{{ parseInt((funNum % 10000)/1000) }}</div>
								<div class="numberli">{{ parseInt((funNum % 1000)/100) }}</div>
								<div class="numberli">{{ parseInt((funNum % 100)/10) }}</div>
								<div class="numberli">{{ parseInt(funNum % 10) }}</div>
							</div>
						</div>
						<div style="width: 49%;height: 100%;display: inline-block;" id="body-li4-2">
						</div>
						<div
							style="position: absolute;width: 100%;bottom: 10px;left: 0;text-align: center;color: white;font-size: 18px;font-weight: 600;">
							运行时长（小时）</div>
					</div>
				</div>
				<div class="center-bottom corner-border" style="display: block;" ref="adressWrap">
					<div style="width: 100%;height: 100%;overflow: scroll;">

						<div class="content-div-check" style="margin: 0 auto;"
							:style="{ width: vWidth + 'px', height: vHeight + 'px', zoom: mapScale}">
							<img :src="backUrl" />
							<div class="robot" ref="robot" v-for="(obj, index) in mapRobotAry" :key="index">
								<div style="white-space: nowrap;">{{ obj.number }}</div>
							</div>
						</div>

					</div>
					<div class="map-btn">
						<el-button type="primary" icon="el-icon-sort"
							style="margin-bottom: 0px;-moz-transform:rotate(-90deg);-webkit-transform:rotate(-90deg);"
							circle @click="ifMapList=!ifMapList"></el-button>
						<el-button type="success" icon="el-icon-zoom-in" circle @click="mapScale += 0.1"></el-button>
						<el-button type="danger" icon="el-icon-zoom-out" circle @click="mapScale -= 0.1"></el-button>
					</div>

					<el-button type="info" v-if="mapAry.length > 4 && ifMapList"
						style="position: absolute;left: 60px;bottom: 60px;padding: 6px;opacity: 0.5;z-index: 99;" circle
						@click="mapScroll('left')">
						<i class="el-icon-caret-left" style="font-size: 25px;"></i>
					</el-button>

					<el-button type="info" v-if="mapAry.length > 4 && ifMapList"
						style="position: absolute;right: 60px;bottom: 60px;padding: 6px;opacity: 0.5;z-index: 99;"
						circle @click="mapScroll('right')">
						<i class="el-icon-caret-right" style="font-size: 25px;"></i>
					</el-button>

					<transition name="el-zoom-in-bottom">
						<div v-show="ifMapList" class="changeImage">
							<div class="img-li" v-for="(item, index) in mapAry" :key="index"
								@click="getMapDetail(index)"
								:style="{backgroundColor: item.check ? '#2b4490' : 'transparent'}">
								<div class="img-tltle" style="margin-bottom: 10px;">{{ item.rName }}</div>
								<el-image style="width: 100px; height: 100px" :src="item.address" fit="scale-down">
								</el-image>
							</div>
						</div>
					</transition>

				</div>
			</div>
			<div class="content-right">
				<div class="content-right-top right-sc-li">
					<div class="right-li-top">
						<div class="echarts-div">
							<div class="eChart-title">实时报警</div>
							<div class="error-list">
								<div>时间</div>
								<div>上报机器</div>
								<div>上报内容</div>
								<div>处理状态</div>
							</div>
							<div class="error-body">
								<div v-for="(obj, index) in eventAry" :key="index"
									:class="obj.results === '1' ? 'body-li' : 'body-li error-li'">
									<div>{{ obj.insDate }}</div>
									<div>{{ obj.rName }}</div>
									<div class="text">{{ obj.eName }}</div>
									<div class="text">{{ obj.resultsName }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="right-li-content"></div>
					<div class="right-li-bottom"></div>
				</div>
				<div class="content-right-content right-sc-li">
					<div class="right-li-top">
						<div class="echarts-div">
							<div class="eChart-title">地图事件数据分析</div>
							<div style="width: 100%;display: inline-block;height: calc(100% - 45px);">
								<div style="width: 49%;height: 100%;display: inline-block;" id="body-li2">
								</div>
								<div style="width: 49%;height: 100%;display: inline-block;" id="body-li2-2">
								</div>
							</div>
						</div>
					</div>
					<div class="right-li-content"></div>
					<div class="right-li-bottom"></div>
				</div>
				<div class="content-right-bottom right-sc-li">
					<div class="right-li-top">
						<div class="echarts-div">
							<div class="eChart-title">事件数据分析</div>
							<div style="width: 100%;display: inline-block;height: calc(100% - 45px);">
								<div style="width: 49%;height: 100%;display: inline-block;" id="body-li3">
								</div>
								<div style="width: 49%;height: 100%;display: inline-block;" id="body-li3-2">
								</div>
							</div>
						</div>
					</div>
					<div class="right-li-content"></div>
					<div class="right-li-bottom"></div>
				</div>
			</div>
		</div>

	</div>
</template>

<style scoped lang="less"></style>

<script>
	import {
		allEventStatistics,
		mapList,
		robotList,
		eventList,
		robotNum,
		eventChart,
		mapEventChart,
		positonList,
		rIndex,
		mapEventLineChart,
		eventLineChart,
		maintainMonthChart,
		maintainYearChart,
		handleTime,
		runTime,
		runMileage
	} from '@/api/index'
	import {
		getToken,
		getItem
	} from '@/utils/auth'
	import IndexSocket from '@/components/IndexSocket.vue'
	import '@/page/newIndex/index/index.less'

	export default {
		name: 'newindex',
		components: {
			IndexSocket
		},
		data() {
			return {
				newTime: new Date(),
				nowTime: new Date().getTime(),
				headUrl: require('../../../../static/img/index_head.png'),
				robotSrc: require('../../../../static/img/xyRobot.png'),
				titleUrl: require('../../../../static/img/title.png'),
				error_ul: require('../../../../static/img/error-list.png'),
				error_li: require('../../../../static/img/error-code.png'),
				robot_ul: require('../../../../static/img/robot-ul.png'),
				robot_li: require('../../../../static/img/robot-li.png'),
				backUrl: '',
				mapAry: [],
				robotAry: [],
				mapRobotAry: [],
				mapRobotColor: ['#FF6600', '#FFFF66', '#336699', '#CC6699', '#FF9933', '#FFFFCC', '#009966', '#663300'],
				vWidth: 0,
				vHeight: 0,
				errorData: {
					totalNum: 0,
					untreatedNum: 0,
					percen: 0,
				},
				eventAry: [],
				errorObj: {
					onDuty: 0,
					totalNum: 0
				},
				showScrollBtn: false,
				ifMapList: false,
				mapScale: 1,
				funNum: 0,
				funReal: 0,
				checkMap: {}
			}
		},
		mounted() {
			// 定时执行保持token有效
			let that = this
			if (getToken()) {
				setInterval(() => {
					that.newTime = new Date()
				}, 1000)
				setInterval(() => {
					rIndex()
				}, 1000 * 60 * 60 * 5)
				let tenID = getItem('tenantInfoId')
				setTimeout(function() {
					that.mapEventChart(tenID)
					that.eventChart(tenID)
				}, 500)
				this.allEventStatistics(tenID)
				this.mapList(tenID)
				this.robotList(tenID)
				this.eventList(tenID)
				this.robotNum(tenID)
				this.mapEventLineChart(tenID)
				this.eventLineChart(tenID)
				this.maintainMonthChart(tenID)
				this.maintainYearChart(tenID)
				this.handleTime(tenID)
				this.runTime(tenID)
			} else {
				that.$message({
					message: '请先登陆',
					type: 'warning',
					duration: '2000'
				});
				setTimeout(() => {
					that.$router.push({
						name: 'login'
					})
				}, 2000)
			}
		},
		updated() {
			let that = this
			if (that.$refs.robot && that.$refs.robot.length > 0) {
				that.$refs.robot.map((v, index) => {
					v.style.top = Number(that.mapRobotAry[index].positon.split(',')[1]) - 10 + 'px'
					v.style.left = Number(that.mapRobotAry[index].positon.split(',')[0]) - 10 + 'px'
				})
			}
		},
		methods: {
			doSocker(socketData) {
				let that = this
				if (socketData.socketType === '1') {
					if (that.checkMap.number === socketData.map) {
						let mapRobotList = []
						that.mapRobotAry.map(v => {
							mapRobotList.push(v.robotId)
							if (v.robotId === socketData.robotId) {
								v.positon = socketData.positon
							}
						})
						if (mapRobotList.indexOf(socketData.robotId) === -1) {
							that.mapRobotAry.push({
								area: socketData.area,
								floor: socketData.floor,
								map: socketData.map,
								number: socketData.fromUserId,
								positon: socketData.positon,
								robotId: socketData.robotId,
								ststus: socketData.ststus,
								ststusName: socketData.ststusName
							})
						}
					}
					for (let i = 0; i < that.robotAry.length; i++) {
						if (that.robotAry[i].robotId === socketData.robotId) {
							that.robotAry[i].ststusName = socketData.ststusName
						}
					}
					that.robotAry = JSON.parse(JSON.stringify(that.robotAry))
					that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
				} else if (socketData.socketType === '2' || socketData.socketType === '4' || socketData.socketType ===
					'6' || socketData.socketType === '7') {
					if (socketData.socketType === '7' && socketData.onlineStatus === '2') {
						that.mapRobotAry.forEach((v, index) => {
							if (v.robotId === socketData.robotId) {
								that.mapRobotAry.splice(index, 1)
							}
						})
						that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
					}
					let tenID = getItem('tenantInfoId')
					that.mapEventChart(tenID)
					that.eventChart(tenID)
					that.allEventStatistics(tenID)
					that.mapEventLineChart(tenID)
					that.eventLineChart(tenID)
					that.eventList(tenID)
					that.robotList(tenID)
					that.robotNum(tenID)
				}
			},
			mapScroll(type) {
				let leftData = document.getElementsByClassName('changeImage')[0].scrollLeft
				if (type === 'left') {
					document.getElementsByClassName('changeImage')[0].scrollLeft = leftData - 100
				} else {
					document.getElementsByClassName('changeImage')[0].scrollLeft = leftData + 100
				}
			},
			runTime(id) {
				let that = this
				runTime(id).then(res => {
					if (res.data && res.data.days) {
						that.funNum = Number(res.data.days) * 24
						that.funReal = Number(res.data.days)
					}
				})
			},
			runMileage(id) {
				let that = this
				runMileage(id).then(res => {
					that.Echarts4(res.data)
				})
			},
			Echarts4(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li4-2'))
				myChart.clear();
				var option = {
					series: [{
						radius: '140%',
						type: 'gauge',
						startAngle: 180,
						endAngle: 0,
						min: 0,
						max: echarArray.max,
						splitNumber: echarArray.splitNumber,
						center: ['50%', '75%'],
						itemStyle: {
							color: 'rgb(92,123,198)',
							shadowColor: 'rgba(0,138,255,0.45)',
							shadowBlur: 10
						},
						progress: {
							show: true,
							roundCap: true,
							width: 10
						},
						pointer: {
							icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
							length: '40%',
							width: 5,
							offsetCenter: [0, '-20%']
						},
						axisTick: {
							splitNumber: 2,
							lineStyle: {
								width: 2,
								color: '#999'
							}
						},
						axisLine: {
							roundCap: true,
							lineStyle: {
								width: 10,
								color: [
									[240, 'rgb(153,153,153)']
								]
							}
						},
						splitLine: {
							length: 12,
							lineStyle: {
								width: 3,
								color: '#999'
							}
						},
						axisLabel: {
							distance: 10,
							color: '#999',
							fontSize: 12
						},
						title: {
							show: false
						},
						detail: {
							width: '60%',
							lineHeight: 50,
							height: 40,
							offsetCenter: [0, '0%'],
							valueAnimation: true,
							formatter: function(value) {
								return '{value|' + value.toFixed(0) + '}{unit|km}';
							},
							rich: {
								value: {
									fontSize: 20,
									fontWeight: 'bolder',
									color: 'gray'
								},
								unit: {
									fontSize: 15,
									color: '#999'
								}
							}
						},
						data: [{
							value: echarArray.splitNumber
						}]
					}]
				};
				myChart.setOption(option)
			},
			getMapDetail(index) {
				let that = this
				that.mapAry.map(v => {
					v.check = false
				})
				that.mapAry[index].check = true
				that.checkMap = that.mapAry[index]
				that.mapAry = JSON.parse(JSON.stringify(that.mapAry))
				that.backUrl = that.mapAry[index].address
				that.vWidth = Number(that.mapAry[index].width)
				that.vHeight = Number(that.mapAry[index].height)
				this.computedScale()
				positonList({
					number: that.mapAry[index].number,
					userId: getItem('userInfo').staffId
				}).then(res => {
					if (res && res.data.length > 0) {
						that.mapRobotAry = res.data
					} else {
						that.mapRobotAry = []
					}
				})
			},
			robotNum(id) {
				let that = this
				robotNum(id).then(res => {
					that.errorObj = res.data
					if (!that.errorObj.onDuty) {
						that.errorObj.onDuty = 0
					}
					if (!that.errorObj.totalNum) {
						that.errorObj.totalNum = 0
					}
				})
			},
			mapEventChart(id) {
				let that = this
				mapEventChart(id).then(res => {
					that.Echarts2(res.data)
				})
			},
			eventChart(id) {
				let that = this
				eventChart(id).then(res => {
					that.Echarts3(res.data)
				})
			},
			eventList(id) {
				let that = this
				eventList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.eventAry = res.data
					} else {
						that.eventAry = []
					}
				})
			},
			mapEventLineChart(id) {
				let that = this
				mapEventLineChart(id).then(res => {
					that.Echarts21(res.data)
				})
			},
			eventLineChart(id) {
				let that = this
				eventLineChart(id).then(res => {
					that.Echarts31(res.data)
				})
			},
			maintainYearChart(id) {
				let that = this
				maintainYearChart(id).then(res => {
					that.Echarts11(res.data)
				})
			},
			handleTime(id) {
				let that = this
				handleTime(id).then(res => {
					that.Echarts0(res.data)
				})
			},
			maintainMonthChart(id) {
				let that = this
				maintainMonthChart(id).then(res => {
					that.Echarts1(res.data)
				})
			},
			robotList(id) {
				let that = this
				robotList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.robotAry = res.data
					} else {
						that.robotAry = []
					}
				})
			},
			mapList(id) {
				let that = this
				mapList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.mapAry = res.data
						that.mapAry.map(v => {
							v.check = false
						})
						that.backUrl = that.mapAry[0].address
						that.vWidth = Number(that.mapAry[0].width)
						that.vHeight = Number(that.mapAry[0].height)
						that.getMapDetail(0)
					} else {
						that.mapAry = []
					}
				})
			},
			allEventStatistics(id) {
				let that = this
				allEventStatistics(id).then(res => {
					if (res.data) {
						that.errorData = res.data
						that.errorData.percen = (that.errorData.untreatedNum / that.errorData.totalNum) * 100
					}
				})
			},
			Echarts0(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li0'))
				myChart.clear();
				let datas = [echarArray]
				var option = {
					title: {
						show: true,
						text: '事件处理时效分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "45%"],
							// itemStyle: {
							//     normal: {
							//         color(params) {
							//             var colorList = ['rgb(254,84,84)','rgb(255,192,70)', 'rgb(209,72,254)','rgb(50,186,254)', 'red', 'yellow', 'green'];
							//             return colorList[params.dataIndex]
							//         }
							//     }
							// },
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15
									},
									textStyle: {
										color: 'black',
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			Echarts11(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li1-1'))
				myChart.clear();
				let option = {
					title: {
						show: true,
						text: '年度分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					xAxis: {
						type: 'category',
						data: echarArray.xData,
						axisLabel: {
							rotate: 40
						},
					},
					yAxis: {
						type: 'value'
					},
					grid: {
						top: '5%',
						left: '2%',
						bottom: '10%',
						right: '1%',
						containLabel: true,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					series: [{
						data: echarArray.data,
						type: 'bar',
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)'
						},
						itemStyle: {
							normal: {
								color: function(params) {
									var colorList = ['#6666FF', '#FFFF33', '#99CCFF', '#669933',
										'#0099CC', '#FF6600', '#FFFF66', '#336699', '#CC6699',
										'#FF9933', '#FFFFCC', '#009966', '#663300'
									]
									return colorList[params.dataIndex]
								}
							}
						}
					}]
				};
				myChart.setOption(option)
			},
			Echarts1(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li1'))
				myChart.clear();
				echarArray.map(v => {
					v.value = Number(v.number)
				})
				let datas = [echarArray]
				var option = {
					title: {
						show: true,
						text: '当月分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					grid: {
						left: '5%',
						right: '4%',
						bottom: '10%',
						top: '50%'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "45%"],
							// itemStyle: {
							//     normal: {
							//         color(params) {
							//             var colorList = ['#0000CC','#333300','#99CCFF','#FFCC33','#FFFF33','#66CC00'];
							//             return colorList[params.dataIndex]
							//         }
							//     }
							// },
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15
									},
									textStyle: {
										color: 'black'
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points,
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			Echarts21(echarArray) {
				let that = this
				var myChart = this.$echarts.init(document.getElementById('body-li2-2'))
				myChart.clear();
				echarArray.mapEvent.forEach((v, index) => {
					v.type = "line"
					// v.itemStyle = {
					//     normal: {
					//         lineStyle: {
					//             color: that.mapRobotColor[index]
					//         }
					//     }
					// }
				})

				var option = {
					title: {
						show: true,
						text: '近七日分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					tooltip: {
						trigger: 'axis'
					},
					// legend: {
					//   data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
					// },
					grid: {
						top: '10%',
						left: '5%',
						right: '1%',
						bottom: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						axisLabel: {
							rotate: 40
						},
						data: echarArray.date
					},
					yAxis: {
						type: 'value'
					},
					series: echarArray.mapEvent
				};
				myChart.setOption(option)
			},
			Echarts2(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li2'))
				myChart.clear();
				echarArray.map(v => {
					v.value = Number(v.number)
				})
				var datas = [echarArray]
				var option = {
					title: {
						show: true,
						text: '当日分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					grid: {
						left: '5%',
						right: '4%',
						bottom: '10%',
						top: '50%'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "45%"],
							// itemStyle: {
							//     normal: {
							//         color(params) {
							//             var colorList = ['#FF6600', '#FFFF66', 'blue', '#009966', '#FF9933', '#FFFFCC', '#009966', '#336699', '#663300'];
							//             return colorList[params.dataIndex]
							//         }
							//     }
							// },
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15
									},
									textStyle: {
										color: 'black'
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			Echarts31(echarArray) {
				let that = this
				var myChart = this.$echarts.init(document.getElementById('body-li3-2'))
				myChart.clear();
				echarArray.event.forEach((v, index) => {
					v.type = "line"
					// v.itemStyle = {
					//     normal: {
					//         lineStyle: {
					//             color: that.mapRobotColor[index]
					//         }
					//     }
					// }
				})
				var option = {
					title: {
						show: true,
						text: '近七日分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						top: '10%',
						left: '5%',
						right: '1%',
						bottom: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						axisLabel: {
							rotate: 40
						},
						data: echarArray.date
					},
					yAxis: {
						type: 'value'
					},
					series: echarArray.event
				};
				myChart.setOption(option)
			},
			Echarts3(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li3'))
				myChart.clear();
				echarArray.map(v => {
					v.value = Number(v.number)
				})
				var datas = [echarArray]
				var option = {
					title: {
						show: true,
						text: '当日分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "45%"],
							// itemStyle: {
							//     normal: {
							//         color(params) {
							//             var colorList = ['#99CCFF','#FFCC33','#FFFF33','#0000CC','#333333', '#333300'];
							//             return colorList[params.dataIndex]
							//         }
							//     }
							// },
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15
									},
									textStyle: {
										color: 'gray'
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout: function(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			computedScale() {
				this.mapScale = 1
				this.$nextTick().then(() => {
					let oW = this.$refs.adressWrap.offsetWidth
					let oH = this.$refs.adressWrap.offsetHeight
					if (this.vWidth != oW || this.vHeight != oH) {
						let wScale = oW / this.vWidth
						let hScale = oH / this.vHeight
						this.mapScale = Math.min(wScale, hScale);
					}
				})
			}
		},
		watch: {
			newTime: {
				deep: true,
				immediate: true,
				handler(newData, oldData) {
					let that = this
					if (getToken()) {
						let tenID = getItem('tenantInfoId')
						if (newData.getMinutes() === 0 && newData.getSeconds() === 0) {
							that.runTime(tenID)
							that.handleTime(tenID)
						}
						if (newData.getHours() === 0 && newData.getMinutes() === 0 && newData.getSeconds() === 0) {
							that.maintainMonthChart(tenID)
							that.maintainYearChart(tenID)
						}
					}
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/page/newIndex/index/index.vue